import { render, staticRenderFns } from "./EditCombo.vue?vue&type=template&id=65676774&scoped=true&"
import script from "./EditCombo.vue?vue&type=script&lang=js&"
export * from "./EditCombo.vue?vue&type=script&lang=js&"
import style0 from "./EditCombo.vue?vue&type=style&index=0&id=65676774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65676774",
  null
  
)

export default component.exports